export const AuditAction = {
  UNAVAILABLE: 'unavailable',
  SET_AS_AVAILABLE: 'setAsAvailable',
  AUDIT: 'audit',
  CONFIRM: 'confirm',
  NOTE: 'note',
  PRODUCT_PROTECTION: 'productprotection',
  PRODUCT_PROTECTION_CONFIRM: 'productprotectionconfirmed',
};

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];
